import { createSlice } from '@reduxjs/toolkit';
import { emptyFetchState } from '../emptyState';
import { fetchStatus } from '../status';
import { getAppReportOptions } from 'api';

// Then, handle actions in your reducers:
const appReportOptionsSlice = createSlice({
  name: 'appReportOptions',
  emptyFetchState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    appReportOptionsFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    appReportOptionsFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    appReportOptionsFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    appReportOptionsResetState: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  appReportOptionsFetchStart,
  appReportOptionsFetchSuccess,
  appReportOptionsFetchFail,
  appReportOptionsResetState,
} = appReportOptionsSlice.actions;

// The reducer
export const appReportOptionsReducer = appReportOptionsSlice.reducer;

// Asynchronous thunk action
export const appReportOptionsFetch = (id: string) => (dispatch) => {
  dispatch(appReportOptionsFetchStart());

  getAppReportOptions(id)
    .then((appReportOptions) => {
      dispatch(appReportOptionsFetchSuccess(appReportOptions.data));
    })
    .catch((error) => {
      dispatch(appReportOptionsFetchFail(error));
    });
};
